<nav class="linq-global-menu">
	<ng-material-multilevel-menu class="linq-ng-material-multilevel-menu" [configuration]="menuConfig" [items]="menuItems"
		*ngIf="menuItems && menuItems.length > 0"></ng-material-multilevel-menu>
</nav>
